import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./GroupDetail.css";
import CardEvento from "../../events/CardEvento/CardEvento";
import iconGrupo from "../../../assets/home/evento_1.png"; // Usado en el mock

// Datos de ejemplo simulando la respuesta de la API para un grupo detallado
const mockGroupDetail = {
  id: 123,
  title: "Los amigos del arte",
  creator: "Julian Velasquez Paz",
  fundado: "15 de julio de 2023",
  location: "Lima - Perú",
  isMember: false, // Cambiado a false para mostrar el botón "Unirme" por defecto
  isOwner: false,
  description:
    "Ven y únete a nuestra comunidad de amantes de los juegos de mesa para una noche inolvidable llena de diversión y camaradería. Te invitamos a sumergirte en el emocionante mundo de los juegos de mesa en un ambiente acogedor y lleno de entusiasmo. Ya seas un jugador experimentado o un principiante curioso, serás bienvenido en nuestro evento. Trae tus juegos favoritos y compártelos con otros apasionados. Además, te invitamos a explorar nuevas amistades y compartir intereses comunes en un ambiente relajado y amigable. ¡No te lo pierdas!",
  imageUrl: iconGrupo,
  memberCount: 40,
  recentEvents: [
    {
      id: 1,
      title: "Muestra teatral El Quijote",
      date: "15 de agosto 2023",
      time: "18:40 pm",
      location: "Av. Arboleda Surco - Lima",
      tags: ["I", "A", "E"],
      attendees: 120,
      imageUrl: iconGrupo,
    },
    {
      id: 2,
      title: "Taller de Mímica Clásica",
      date: "05 de septiembre 2023",
      time: "20:00 pm",
      location: "Centro Cultural UPC",
      tags: ["J", "P", "L"],
      attendees: 55,
      imageUrl: iconGrupo,
    },
  ],
};

// Componente para la Badge del Creador (Se mantiene igual)
const CreatorBadge = ({ initial, creatorName }) => (
  <div className="d-flex align-items-center mb-4">
    <span className="creator-initial-badge me-2">{initial}</span>
    <div>
      Creado por
      <div className="creator-name fw-bold">{creatorName}</div>
    </div>
  </div>
);

const GroupDetail = ({ type = "view" }) => {
  const { hashedId } = useParams();
  console.log("ID HASHEADO DE LA URL:", hashedId);

  const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    try {
      if (!hashedId || hashedId.length < 2) {
        throw new Error("ID de grupo inválido o no encontrado.");
      }

      setTimeout(() => {
        // Clonamos mockGroupDetail y lo asignamos.
        // Si isMember es 'false' por defecto en mockGroupDetail, se mostrará "Unirme".
        setGroup({ ...mockGroupDetail, id: hashedId });
        setIsLoading(false);
      }, 500);
    } catch (error) {
      console.error("Error al cargar ID:", error);
      setApiError("No se pudo cargar el detalle del grupo.");
      setIsLoading(false);
    }
  }, [hashedId]);

  const handleMainAction = () => {
    if (!group) return;

    if (group.isOwner && type === "admin") {
      console.log(`Guardando cambios de administración para ${group.title}`);
    } else if (group.isMember) {
      console.log(`Saliendo del grupo: ${group.title}`); // Aquí iría la llamada a la API para salir
      setGroup((prev) => ({ ...prev, isMember: false })); // Simula salir
    } else {
      console.log(`Uniéndose al grupo: ${group.title}`); // Aquí iría la llamada a la API para unirse
      setGroup((prev) => ({ ...prev, isMember: true })); // Simula unirse
    }
  };

  let buttonLabel = "Unirme";
  let buttonClass = "btn-primary"; // Color principal del botón Unirme
  if (group) {
    if (group.isOwner) {
      buttonLabel = type === "admin" ? "Guardar Cambios" : "Administrar Grupo";
      buttonClass = type === "admin" ? "btn-success" : "btn-warning"; // Colores ajustados
    } else if (group.isMember) {
      buttonLabel = "Unido"; // Etiqueta cuando ya está unido
      buttonClass = "btn-success disabled"; // Deshabilitado y verde si ya está unido
    }
  }

  if (isLoading) {
    return (
      <div className="text-center mt-5">Cargando detalles del grupo...</div>
    );
  }

  if (apiError || !group) {
    return (
      <div className="alert alert-danger text-center mt-5">
        Error: {apiError || "Grupo no encontrado."}
      </div>
    );
  }

  const isAdminView = group.isOwner && type === "admin";

  if (!group.isOwner && type === "admin") {
    navigate(`/groups/${hashedId}/detalle`, { replace: true });
    return null;
  }

  return (
    <div className="container mt-5 group-detail-container">
      {/* Botón Volver */}
      <button className="btn-volver mb-4" onClick={() => navigate(-1)}>
        <i className="bi bi-arrow-left me-2"></i> Volver
      </button>

      <div className="row">
        {/* Columna de Contenido (Izquierda en desktop, Arriba en móvil) */}

        <div className="col-12 col-md-5 group-info-column order-md-2">
          {/* Nueva clase */}
          <h1 className="group-detail-title">{group.title}</h1>

          <CreatorBadge
            initial={group.creator.charAt(0)}
            creatorName={group.creator}
          />

          <div className="group-meta-info mb-4">
            <p className="meta-item">
              <i className="bi bi-geo-alt-fill me-2"></i> {group.location}
            </p>

            <p className="meta-item">
              <i className="bi bi-calendar-check-fill me-2"></i> Fundado{" "}
              {group.fundado}
            </p>
          </div>
          {/* Botón Compartir */}
          <button className="btn-share d-flex align-items-center mb-4">
            <i className="bi bi-share-fill me-2"></i> Compartir
          </button>
          {/* Botón de Acción Principal */}
          <button
            className={`btn ${buttonClass} btn-lg fw-bold btn-main-action mb-4`}
            onClick={!group.isMember ? handleMainAction : null}
            disabled={group.isMember && !group.isOwner} // Deshabilita el botón "Unido"
          >
            {buttonLabel}
          </button>
        </div>
        {/* Columna de Imagen (Derecha en desktop, Arriba en móvil) */}

        <div className="col-12 col-md-7 order-md-1 mb-4 mb-md-0 group-image-col">
          {/* Nueva clase */}
          <div className="group-image-container">
            <img
              src={group.imageUrl}
              alt={`Imagen de ${group.title}`}
              className="group-detail-img"
            />
          </div>
        </div>
      </div>

      {/* Sección "La Comunidad" - "Descubre esta experiencia" y su contenido */}

      <div className="row mt-1 mb-5">
        {/* Ocupa todo el ancho */}
        <div className="col-12">
          <h3 className="section-title">La Comunidad</h3>
          <h4 className="section-subtitle mb-3">Descubre esta experiencia</h4>

          <div className="group-description">
            <p>{group.description}</p>
          </div>
        </div>
      </div>

      {/* Sección "Ver mi eventos" (Solo visible en vista normal y si hay eventos) */}

      {!isAdminView && group.recentEvents && group.recentEvents.length > 0 && (
        <div className="row">
          <div className="col-12">
            <h3 className="section-title-events mb-4">Ver mis eventos</h3>
            {/* Nuevo título de eventos */}
            <div className="row events-gallery">
              {group.recentEvents.map((event) => (
                <div key={event.id} className="col-12 col-md-6 mb-4">
                  {/* col-md-6 para 2 eventos por fila */}

                  <CardEvento
                    title={event.title}
                    date={event.date}
                    time={event.time}
                    location={event.location}
                    tags={event.tags}
                    attendees={event.attendees}
                    imageUrl={event.imageUrl}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {isAdminView && (
        <div className="alert alert-info mt-4">
          Estás en modo **Administración**. Aquí puedes editar el título, la
          descripción, gestionar miembros, etc.
        </div>
      )}
    </div>
  );
};

export default GroupDetail;
